<template>
  <div class="app-container">
    <div class="info">
      <div class="item mr40">
        <span class="label"><strong>客户名称：</strong></span>
        <span class="value">{{ cname || '--' }}</span>
      </div>
      <div class="item mr40">
        <span class="label"><strong>门店名称：</strong></span>
        <span class="value">{{ shopName || '--' }}</span>
      </div>
      <div class="item mr40">
        <span class="label"><strong>SolutionID：</strong></span>
        <span class="value">{{ productId }}</span>
      </div>
      <div class="item mr40">
        <span class="label"><strong>shopID：</strong></span>
        <span class="value">{{ shopId || '--' }}</span>
      </div>
      <div class="item">
        <span class="label"><strong>状态：</strong></span>
        <span class="value">{{ formatLabel(runningStatusList, parseInt(status)) || '--' }}</span>
      </div>
    </div>
    <div class="mt20">
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane lazy label="盒子" name="0"><Box /></el-tab-pane>
        <el-tab-pane lazy label="摄像头" name="1"><Camera /></el-tab-pane>
        <el-tab-pane v-if="showNvr" lazy label="NVR" name="2"><NVR /></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Box from './box.vue'
import Camera from './camera.vue'
import NVR from './NVR.vue'
import { formatLabel } from 'src/utils/common'
import { runningStatusList } from 'src/utils/dict'

export default {
  components: {
    Box,
    Camera,
    NVR
  },
  data() {
    const { cname, shopName, productId, shopId, status } = this.$route.query

    return {
      activeTab: this.$route.query.type || '0',
      cname,
      shopName,
      productId,
      shopId,
      status,
      runningStatusList,
    }
  },
  computed: {
    showNvr() {
      return this.$route.name === 'retail-traffic-device-index'
    }
  },
  methods: {
    handleClick(tab) {
      this.activeTab = tab.name
      this.$router.push({ query: { ...this.$route.query, type: tab.name } })
    },
    formatLabel,
  },
}
</script>

<style lang="less" scoped>
.info {
  display: flex;
  padding: 20px 0;
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  word-break: break-all;
  flex-wrap: wrap;
  gap: 12px;
}
</style>
